import { useProfile } from "@/context/useProfileProps";
import { getImageEnvUrl } from "@/utils";
import Image from "next/image";
import React from "react";

type AvatarProps = {
  avatar: string | null;
  nameInitial: string;
};

const Avatar = ({ avatar, nameInitial }: AvatarProps) => {
  const { isMobile } = useProfile();
  return (
    <div
      className={`bg-brand-secondary relative flex items-center justify-center overflow-hidden rounded-full ${isMobile ? "h-12 w-12 border" : "h-24 w-16"}`}
    >
      {avatar ? (
        <Image
          src={getImageEnvUrl(avatar)}
          alt="profile picture"
          fill
          style={{ objectFit: "cover" }}
        />
      ) : (
        <span className="text-brand-primary absolute text-lg font-bold">
          {nameInitial ? nameInitial : "S"}
        </span>
      )}
    </div>
  );
};

export default Avatar;
